import { useContext } from "react";
import { configContext } from "../../context/configContext";
import { IConfigState, ISelectValue } from "../constants/app.dto";
import * as GlobalData from "../util/GlobalData";

interface IIdToText extends IConfigState {
  workPlace: ISelectValue[];
  workHours: ISelectValue[];
  gender: ISelectValue[];
  expertise: ISelectValue[];
  documents: ISelectValue[];
}

export const useIdToText = () => {
  const { configData } = useContext(configContext);

  // converting data to correct format
  const workPlace = GlobalData.workPlace.map((wp) => ({ id: wp.value, name: wp.label, status: "1" }));
  const workHours = GlobalData.workHours.map((wp) => ({ id: wp.value, name: wp.label, status: "1" }));
  const gender = GlobalData.genderValues.map((wp) => ({ id: wp.value, name: wp.label, status: "1" }));
  const expertise = GlobalData.levelExpertise.map((wp) => ({ id: wp.value, name: wp.label, status: "1" }));
  const documents = GlobalData.documentValues.map((wp) => ({ id: wp.value, name: wp.label, status: "1" }));

  const geoDepartments = configData.geoDepartments.map((dp: any) => ({
    id: dp.idDepartments + '', name: dp.departamento, status: "1"
  }));

  const data: IIdToText = {
    ...configData,
    workPlace,
    workHours,
    geoDepartments,
    gender,
    expertise,
    documents,
  };

  const converIdToText = (id: string, group: keyof IIdToText) => {
    const obj = data[group].filter((item: ISelectValue) =>
      item.id === id
    )[0];

    return obj?.name || '';
  }

  return { converIdToText };
}